import { singlePost } from '@/api'
import { FETCH_POST } from '@/store/actions.type'
import { START_LOADING_POST, END_LOADING_POST } from '@/store/mutations.type'

const state = {
	data: []
}
const actions = {
	async [FETCH_POST]({ commit }, postid) {
		return singlePost.getPost(postid).then(({ data }) => {
			var post = JSON.parse(JSON.stringify(data.post))
			var currentState = state.data
			currentState.push(post)
			commit(END_LOADING_POST, currentState)
		})
	}
}
const mutations = {
	[END_LOADING_POST](state, postdata) {
		state = {
			data: postdata
		}
	}
}

const getters = {
	rvsinglepost(state) {
		return state.data
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/post.js